<template>
  <tr-page-section
    title="Autenticação em 2 fatores"
    :no-margin="true"
  >
    <template #description>
      <tr-typography>
        Ativando a autenticação em 2 fatores, sempre que você fizer seu login na Transfeera, será solicitado um novo
        código, que só você terá em um aplicativo no seu smartphone!
        <tr-typography strong="true">
          Ative agora e fique ainda mais protegido!
        </tr-typography>
      </tr-typography>
    </template>
    <tfa-container />
  </tr-page-section>
</template>

<script>
import TfaContainer from './TfaContainer.vue';

export default {
  components: {
    TfaContainer
  }
};
</script>
